import styled from 'styled-components';

export const ButtonMainContainerStyle = styled.div`
  a,
  button {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 180px;
    height: 120px;
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.normal;
    }};
    box-shadow: ${({ theme }) => {
      return theme.shadow;
    }};

    margin-right: 30px;
    margin-bottom: 30px;

    background-color: ${(props) => props.color};

    text-decoration: none;
    cursor: pointer;
    transition: transform 200ms ease;

    &:hover {
      transform: scale(1.05);
    }

    span {
      width: 95%;
      font-size: ${({ theme }) => {
        return theme.fonts.size.small;
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin;
      }};
      color: ${({ theme }) => {
        return theme.colors.white;
      }};
      margin-top: 10px;
      text-align: center;
    }

    img {
      width: 40px;
    }
  }
`;
